<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="locationsField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeLocationsField] ? 'Exclude' : 'Include')} Locations`"
      :options="locations.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one location'
      ]"
    />
    <model-form-toggle
      :field="`conditionsRequirements.${excludeLocationsField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITIONS_REQUIREMENTS } from 'src/models/tip/TipShareRule'

export default {
  name: 'LocationsConditionForm',
  configuration: ['locations'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    locationsField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.LOCATIONS
    },
    excludeLocationsField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.EXCLUDE_LOCATIONS
    }
  }
}

</script>
